<template>
    <div>
        <section>
            <h1 class="h2 mt-4" v-if="!isShopUser">Sprawdź dane</h1>

            <p
                v-if="!isShopUser"
                v-text="$brand.settings.mainUserData.subTitle"
                class="page-lead mb-4"
            />

            <page-preloader
                v-if="!userData || userDataStatus === 'loading'"
            ></page-preloader>
            <div v-else class="row">
                <div class="col-lg-4 mb-4 mb-lg-0" v-if="!isShopUser">
                    <div class="card min-h-0 p-4">
                        <form action="">
                            <h2 class="h6 mb-4">Dane właściciela konta</h2>
                            <the-form
                                class="cux-exclude"
                                :formFields="mainDataForm"
                                :data="userData"
                            />
                        </form>
                    </div>
                </div>

                <div class="col-lg-4 mb-4 mb-lg-0">
                    <div class="card min-h-0 p-4">
                        <h2 class="h6 mb-4">Zmień hasło</h2>
                        <div style="margin-top: -12px">
                            Hasło powinno zawierać:
                            <ul>
                                <li>przynajmniej 6 znaków</li>
                                <li>co najmniej 1 małą literę</li>
                                <li>co najmniej 1 wielką literę</li>
                                <li>co najmniej 1 cyfrę</li>
                                <li>co najmniej 1 znak specjalny (@$!%*?&)</li>
                            </ul>
                        </div>
                        <the-input
                            class="cux-exclude mb-4"
                            id="mp-password"
                            type="password"
                            label="Podaj aktualne hasło"
                            name="mp-password"
                            :text="passwords.oldPassword"
                            :disabled="newPassLoader"
                            @input="passwords.oldPassword = $event"
                        />
                        <the-input
                            class="cux-exclude mb-4"
                            id="mp-newPassword"
                            type="password"
                            label="Nowe hasło"
                            name="mp-newPassword"
                            :text="passwords.newPassword"
                            :disabled="newPassLoader"
                            @input="passwords.newPassword = $event"
                        />
                        <the-input
                            class="cux-exclude mb-0"
                            id="mp-repeatNewPassword"
                            type="password"
                            label="Powtórz nowe hasło"
                            name="mp-repeatNewPassword"
                            :invalid="invalidRepeat"
                            :invalid-feedback="'Podane hasła nie są identyczne.'"
                            :text="passwords.repeatNewPassword"
                            :disabled="newPassLoader"
                            @input="passwords.repeatNewPassword = $event"
                        />
                        <the-btn
                            id="login"
                            class="mt-4 btn-block btn-secondary"
                            text="Zapisz zmiany"
                            :icon="newPassLoader ? 'Spinner' : ''"
                            :loading-status="newPassLoader ? 'loading' : 'idle'"
                            @click="setUserNewPassword"
                        />
                    </div>
                </div>

                <!-- TODO: TEMP showRegisterData parameter, remove when ready -->
                <div
                    class="col-lg-4 mb-4 mb-lg-0"
                    v-if="registerData && showRegisterData"
                >
                    <div class="card p-4">
                        <form action="">
                            <h2 class="h6 mb-4">Dane rejestrowe</h2>
                            <the-form
                                class="mb-4"
                                :formFields="registerDataForm"
                                :data="registerData"
                                :errors="registerDataErrors"
                            />

                            <button
                                class="btn btn-block btn-secondary"
                                type="submit"
                                :disabled="
                                    JSON.stringify(registerData) ===
                                        JSON.stringify(registerDataInitial)
                                "
                                @click.prevent="sendRegisterData"
                            >
                                Zapisz zmiany
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </section>

        <billing-data-management />
    </div>
</template>

<script>
import BillingDataManagement from './BillingDataManagement.vue'
import captcha from '@/mixins/captcha'

export default {
    mixins: [captcha],

    components: {
        BillingDataManagement
    },
    data() {
        return {
            newPassLoader: false,
            passwords: {
                oldPassword: '',
                newPassword: '',
                repeatNewPassword: ''
            },
            invalidRepeat: false,
            mainDataForm: [
                {
                    name: 'mp-mail',
                    title: 'E-mail',
                    disabled: true,
                    text: this.$store.getters.getLogin,
                    path: 'email'
                },
                {
                    name: 'mp-name',
                    title: 'Imię',
                    disabled: true,
                    path: 'name'
                },
                {
                    name: 'mp-last-name',
                    title: 'Nazwisko',
                    disabled: true,
                    path: 'surname'
                },
                {
                    name: 'mp-phone',
                    title: 'Telefon kontaktowy',
                    disabled: true,
                    path: 'phone'
                }
            ],
            // TODO: TEMP showRegisterData parameter, remove when ready
            showRegisterData: false,
            registerDataInitial: null,
            registerDataForm: [
                {
                    name: 'rd-nip',
                    title: 'NIP',
                    disabled: true,
                    path: 'nip'
                },
                {
                    name: 'rd-regon',
                    title: 'REGON',
                    disabled: true,
                    path: 'regon'
                },
                {
                    name: 'rd-full-name',
                    title: 'Nazwa firmy',
                    disabled: false,
                    path: 'full_name'
                },
                {
                    name: 'rd-street',
                    title: 'Ulica',
                    disabled: false,
                    path: 'headquarters_address.street'
                },
                {
                    name: 'rd-building',
                    title: 'Numer budynku',
                    class: 'col-6',
                    disabled: false,
                    path: 'headquarters_address.building'
                },
                {
                    name: 'rd-local',
                    title: 'Numer lokalu',
                    class: 'col-6',
                    disabled: false,
                    path: 'headquarters_address.local'
                },
                {
                    name: 'rd-postal-code',
                    title: 'Kod pocztowy',
                    class: 'col-6',
                    disabled: false,
                    path: 'headquarters_address.postalCode'
                },
                {
                    name: 'rd-city',
                    title: 'Miasto',
                    class: 'col-6',
                    disabled: false,
                    path: 'headquarters_address.city'
                },
                {
                    name: 'rd-bank-account-number',
                    title: 'Numer rachunku bankowego',
                    disabled: false,
                    path: 'bank_account_number',
                    format: 'bankAccount'
                },
                {
                    type: 'ui-virtual-list',
                    name: 'rd-settlement-method',
                    path: 'settlement_method',
                    value: null,
                    floatTitle: true,
                    searcher: false,
                    label: 'Sposób rozliczenia',
                    getter: 'getAvailableSettlementsMethod'
                },
                {
                    name: 'rd-phone',
                    title: 'Numer telefonu do właściciela',
                    disabled: false,
                    path: 'phone'
                }
            ],
            registerDataErrors: {}
        }
    },
    computed: {
        isShopUser() {
            return this.$store.getters.isShopUser
        },
        userData() {
            return this.$store.getters.getUser
        },
        registerData() {
            return this.$store.getters.getRegisterData
        },
        userDataStatus() {
            return this.$store.getters.getUserStatus
        }
    },
    methods: {
        fetch() {
            this.$store
                .dispatch('extendedDataFetch', {
                    includes: 'companies'
                })
                .then(res => {
                    if (res) {
                        this.registerDataInitial = JSON.parse(
                            JSON.stringify(this.$store.getters.getRegisterData)
                        )
                    }
                })
        },
        async setUserNewPassword() {
            if (this.newPassLoader) {
                // Prevent multiple clicks while loading
                return
            }

            const { newPassword, repeatNewPassword } = this.passwords

            if (newPassword === '' || newPassword !== repeatNewPassword) {
                // Show error if new password is empty or doesn't match repeated password
                this.invalidRepeat = true
                return
            }

            // Show loader on button click
            this.newPassLoader = true

            // Mount reCAPTCHA and get token
            await this.mountRecaptcha()

            // Validate new password before sending request
            const invalidateNewPassword = this.invalidateNewPassword(
                this.passwords.newPassword
            )

            if (invalidateNewPassword) {
                // If password contains invalid characters, show notification and stop the process
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: `Hasło zawiera niedozwolone znaki tj '${invalidateNewPassword}'`
                })
                this.newPassLoader = false
                return
            }

            // If validation passed, send request to change password, reset form and loader
            this.invalidRepeat = false
            this.$store.dispatch('setUserNewPassword', {
                ...this.passwords,
                login: this.userData.email
            }).then(res => {
                if (res && res.status === 200) {
                    // Clear password fields after successful password change
                    this.passwords.oldPassword = ''
                    this.passwords.newPassword = ''
                    this.passwords.repeatNewPassword = ''
                }
            }).finally(() => {
                this.newPassLoader = false
            })
        },
        invalidateNewPassword(value) {
            let invalidSpecialChars = ''

            if (
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%&*()\\[\\]?{}()]).{8,}$/.test(
                    value
                )
            ) {
                return false
            } else {
                const specialChars = '<>^_+:;|",./~`-='
                for (let i = 0; i < specialChars.length; i++) {
                    if (value.indexOf(specialChars[i]) > -1) {
                        invalidSpecialChars = invalidSpecialChars.concat(
                            specialChars[i]
                        )
                    }
                }
                return invalidSpecialChars
            }
        },
        sendRegisterData() {
            this.$store.dispatch('setRegisterData').then(res => {
                const errors = {}
                if (res.data.data.errors && res.data.data.errors.length) {
                    res.data.data.errors.forEach(el => {
                        let field = el.field.split('CompanyData.')[1]
                        field = field.replace(
                            /[A-Z]/g,
                            letter => `_${letter.toLowerCase()}`
                        )
                        errors[field] = el.message
                    })
                } else {
                    this.registerDataInitial = JSON.parse(
                        JSON.stringify(this.registerData)
                    )
                }
                this.registerDataErrors = errors
            })
        }
    },
    created() {
        this.fetch()
    }
}
</script>
